import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'

import * as serviceWorkerRegistration from './serviceWorkerRegistration'

const ENABLED_VALUE = 'enabled'

const container = document.getElementById('app')
const root = createRoot(container!)
root.render(<App />)

if (process.env.REACT_APP_USE_SERVICE_WORKER === ENABLED_VALUE) {
  serviceWorkerRegistration.register({
    onSuccess: () => {
      alert(
        'Aplikacja będzie starała się zachować dane w przypadku wykrycia braku połączenia z internetem'
      )
    },
    onUpdate: (registration) => {
      const waitingServiceWorker = registration.waiting

      if (waitingServiceWorker) {
        waitingServiceWorker.addEventListener('statechange', (event: any) => {
          /* tslint:disable no-console */
          if (event?.target?.state === 'activated') {
            const result = window.confirm(
              'Pojawiła się nowa wersja aplikacji, kliknij OK żeby wczytać'
            )

            if (result) {
              window.location.reload()
            }
          }
        })

        waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' })
      }
    },
  })
}
